'use client'

import { useState, useEffect } from 'react'

function getOffsetMinutes(tz) {
  try {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      timeZoneName: 'longOffset',
    }).formatToParts(new Date())
    const tzPart = parts.find((p) => p.type === 'timeZoneName')?.value ?? 'GMT+0:00'
    if (tzPart === 'GMT') return 0
    const m = tzPart.match(/GMT([+-])(\d{2}):(\d{2})/)
    if (!m) return 0
    return (m[1] === '+' ? 1 : -1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10))
  } catch {
    return null
  }
}

function getLocalTime(tz) {
  try {
    return new Intl.DateTimeFormat('en-GB', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(new Date())
  } catch {
    return null
  }
}

export default function TimezoneWidget({ destTimezone, fallback }) {
  const [label, setLabel] = useState(fallback)
  const [localTime, setLocalTime] = useState(null)

  useEffect(() => {
    function update() {
      try {
        const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone
        const userOffset = getOffsetMinutes(userTz)
        const destOffset = getOffsetMinutes(destTimezone)
        if (userOffset === null || destOffset === null) return
        const diffHours = Math.round((destOffset - userOffset) / 60)
        if (diffHours === 0) {
          setLabel('Same timezone')
        } else if (diffHours > 0) {
          setLabel(`+${diffHours}h`)
        } else {
          setLabel(`${diffHours}h`)
        }
        setLocalTime(getLocalTime(destTimezone))
      } catch {}
    }
    update()
    const interval = setInterval(update, 30_000)
    return () => clearInterval(interval)
  }, [destTimezone])

  return (
    <div>
      <span className="mt-1 block font-semibold text-gray-800">{label}</span>
      {localTime && (
        <span className="text-xs text-gray-500">now {localTime} local</span>
      )}
    </div>
  )
}
